import React from "react";
import { withRouter } from "react-router-dom";
import Constantes from "./Constantes";

class Ver extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      DataisLoaded: false,
    };
  }

  componentDidMount() {
    console.log("PROPS:", this.props);

    const { slug } = this.props.match.params;
    console.log("SLUG:", slug);

    fetch(`${Constantes.RUTA_API}/obtenerblogslug.php?id=${slug}`)
      .then((res) => res.json())
      .then((json) => {
        this.setState({
          items: json,
          DataisLoaded: true,
        });
      });
  }

  render() {
    const { DataisLoaded, items } = this.state;

    if (!DataisLoaded) {
      return <h1>Please wait some time...</h1>;
    }

    return (
      <div>
        {items.map((item) => (
          <div
            key={item.id}
            className="flex flex-col lg:w-full lg:pl-96 lg:pr-96 lg:pb-20"
          >
            <img src={item.img} className="rounded-t-lg" alt={item.nombre} />

            <h5 className="text-gray-900 font-bold text-2xl mt-6">
              {item.nombre}
            </h5>

            <div className="flex flex-col mt-10">
              <div dangerouslySetInnerHTML={{ __html: item.contenido }} />
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default withRouter(Ver);
